import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { AdminAuthService } from '../../services/auth/admin-auth.service';
import { performLogout } from '../../helper/session';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'bodyanalytics-logout-button',
  templateUrl: './logout-button.component.html',
  imports: [MatIconModule],
  // Shared with the sibling login button — see ../nav-text-link.scss. The
  // previous default mat-button label was near-black regardless of theme and
  // failed WCAG contrast (1.06:1) on the dark header bar.
  styleUrls: ['../nav-text-link.scss'],
})
export class LogoutButtonComponent {
  protected auth = inject(AuthService);
  protected location = inject(Location);
  private adminAuthService = inject(AdminAuthService);

  logout() {
    performLogout(this.auth, this.adminAuthService);
  }
}
